import cx from "classnames";
import React, { useEffect } from "react";
import styles from "./selectorDropdown.module.scss";
import { CheckIcon } from "@gataca/design-system/web";
import { gaColors } from "../../../assets/globalConstants";
import { useTranslation } from "react-i18next";
import { ISearchSelectorOptModel } from "../../../types/interfaces";

type ISelectorDropdownProps = {
  onChange: (e?: any) => void;
  optionsFilter: ISearchSelectorOptModel[];
  selectedOption?: ISearchSelectorOptModel;
  searchValueOnSelectorChange?: (x?: any) => void;
};

const SelectorDropdown: React.FC<ISelectorDropdownProps> = (props) => {
  const {
    onChange,
    optionsFilter,
    selectedOption,
    searchValueOnSelectorChange,
  } = props;

  const { t } = useTranslation();

  // Consts
  const itemSelectedValue = selectedOption?.value;

  // Functions
  const onItemClick = (item) => {
    onChange && onChange(item);
    searchValueOnSelectorChange && searchValueOnSelectorChange(item);
  };

  // Effects

  useEffect(() => {}, [selectedOption]);

  return (
    <div
      className={styles.optionsCustomContainer}
      role="listbox"
      aria-label="Choose an item">
      {!!optionsFilter?.length ? (
        <>
          {optionsFilter?.map((item, index) => {
            const itemSelected = item?.value === itemSelectedValue;
            return (
              <div
                className={`${styles.menuItem} ${
                  itemSelected ? styles.disabled : ""
                }`}
                role="option"
                key={"option__" + index}
                aria-selected={itemSelected ? true : false}
                id={item}
                onClick={() => {
                  {
                    !itemSelected && onItemClick(item);
                  }
                }}>
                <div className={`${styles.menuItem__option}`}>
                  <p className={cx("buttonSM neutral1000")}>{t(item?.text)}</p>
                </div>
                {itemSelected ? (
                  <div>
                    <CheckIcon color={gaColors.primaryColor} size={"16"} />
                  </div>
                ) : null}
              </div>
            );
          })}
        </>
      ) : null}
    </div>
  );
};

export default SelectorDropdown;
